var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 88.2,
    height: 83.137,
    viewBox: "0 0 88.2 83.137",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#efefef",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#efefef",
    stopOpacity: 0.102
  })), /*#__PURE__*/React.createElement("filter", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_150",
    x: 0,
    y: 3.662,
    width: 88.2,
    height: 79.475,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ffe8b9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_151",
    x: 24.605,
    y: 18.77,
    width: 59.284,
    height: 59.374,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ffe8b9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_600",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 600",
    transform: "translate(4.365)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441_20",
    "data-name": "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441 20",
    transform: "translate(0 0)",
    stroke: "#fff",
    strokeWidth: 2,
    fill: "url(#linear-gradient)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 39,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_100",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 100",
    transform: "translate(10.885 18.893)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -15.25, -18.89)",
    filter: "url(#\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_150)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_150-2",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 150",
    d: "M331.609-344.324a9.6,9.6,0,0,0-2.541-3.954,56.647,56.647,0,0,0-6.484-5.831c-4.077-3.241-8.35-6.214-12.67-9.131a17.445,17.445,0,0,1-4.816-5.39,14.043,14.043,0,0,1-2.316-8.428c.327-5.734,2.621-10.467,7.639-13.677a12.625,12.625,0,0,1,6.041-1.808,16.24,16.24,0,0,1,9.894,2.313,21.384,21.384,0,0,1,4.915,4.448c.337.4.411.308.7-.02,2.461-2.8,5.179-5.281,8.973-6.2,4.151-1,8.221-.992,12,1.3a15.408,15.408,0,0,1,6.27,7.744,17.165,17.165,0,0,1,1.244,6.494,14.323,14.323,0,0,1-2.5,8.009c-.21.316-.36.339-.566.006a3.288,3.288,0,0,0-.437-.532c-.588-.6-.6-.6-.163-1.358a13.172,13.172,0,0,0,.774-11.225,13.549,13.549,0,0,0-6.126-7.731,11.061,11.061,0,0,0-4.212-1.3,14.8,14.8,0,0,0-8.374,1.426,9.141,9.141,0,0,0-2.13,1.4c-1.014.89-2.025,1.781-2.948,2.764a2.662,2.662,0,0,0-.451.65,1.875,1.875,0,0,1-1.751,1.11,1.915,1.915,0,0,1-1.78-1.151,8.562,8.562,0,0,0-1.719-1.934,13.986,13.986,0,0,0-7.092-4.016,14.715,14.715,0,0,0-7,.116,11.134,11.134,0,0,0-5.859,3.973,15.384,15.384,0,0,0-3.37,8.852,13.451,13.451,0,0,0,2.834,9.037,16.738,16.738,0,0,0,4.467,4.264,143.6,143.6,0,0,1,14.11,10.4,38.168,38.168,0,0,1,5.064,4.927c.288.351.481.37.772-.006a20.739,20.739,0,0,1,2.146-2.283c.085-.081.163-.223.3-.17s.1.211.1.325a4.89,4.89,0,0,0,.2,1.72c.076.221-.061.359-.2.508-.465.511-.938,1.016-1.378,1.548A7.788,7.788,0,0,0,331.609-344.324Z",
    transform: "translate(-287.51 411.53)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -15.25, -18.89)",
    filter: "url(#\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_151)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_151-2",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 151",
    d: "M319.866-367.325c0-1.192,0-2.385,0-3.578a1.649,1.649,0,0,1,1.884-1.854c2.118,0,4.237-.013,6.355.01.484,0,.648-.125.642-.627-.026-2.136-.014-4.273-.01-6.409a1.712,1.712,0,0,1,1.872-1.908q3.605-.03,7.21,0a1.782,1.782,0,0,1,1.973,2c.009,2.1.014,4.2-.007,6.3,0,.481.131.649.633.642,2.118-.026,4.237-.013,6.356-.009a1.631,1.631,0,0,1,1.813,1.611,23.834,23.834,0,0,1,.042,2.882c-.011,1.673.085,3.348-.056,5.018a1.549,1.549,0,0,1-1.375,1.472,4.915,4.915,0,0,1-.8.06c-2.029,0-4.059.014-6.088-.006-.461,0-.62.136-.616.61.022,2.118.012,4.237.009,6.356a1.663,1.663,0,0,1-1.808,1.9q-3.685.043-7.37,0a1.649,1.649,0,0,1-1.792-1.861c0-2.118-.014-4.237.009-6.355.006-.487-.136-.653-.632-.648-2.012.022-4.024.01-6.036.007a5.345,5.345,0,0,1-.744-.044,1.578,1.578,0,0,1-1.464-1.67c-.01-1.3,0-2.6,0-3.9Zm18.059-8.58c0-1.086-.017-2.171.009-3.256.01-.442-.133-.584-.577-.58-2.011.019-4.023.007-6.034.009-.714,0-.715,0-.716.7,0,2.03.009,4.059,0,6.088a1.815,1.815,0,0,1-1.945,2.043c-.177.01-.356.006-.533.006-1.888,0-3.775.013-5.661-.009-.493-.006-.648.168-.643.65q.028,3.045,0,6.088c-.006.468.151.615.617.609,2.046-.02,4.094-.01,6.141-.007,1.4,0,2.042.643,2.045,2.062,0,1.993.014,3.987-.007,5.98-.006.478.122.66.626.655q3.043-.037,6.088,0c.471,0,.612-.155.606-.619-.02-2.029-.01-4.058-.007-6.088,0-1.426.656-2.076,2.1-2.079,2.029,0,4.059-.006,6.088,0,.38,0,.591-.065.587-.521q-.026-3.1,0-6.194c0-.445-.192-.538-.581-.534-1.281.013-2.563.009-3.845,0-.906,0-1.818.032-2.719-.045a1.635,1.635,0,0,1-1.625-1.809C337.918-373.8,337.927-374.854,337.926-375.905Z",
    transform: "translate(-280.01 415.73)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeBg);
export default __webpack_public_path__ + "static/media/homeBg.ba2ae3210d5f4d01a1d12c620a6e4032.svg";
export { ForwardRef as ReactComponent };